<template>
  <div>
    <div class="custclue-container">
      <div class="card b-g-w tab-line">
          <div class="title" style="margin-left:10px">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-putcontract"></use>
            </svg>
            <span>
               {{ customer.custName }}
                <!-- <van-tag round type="primary" v-if="customer.contractStatus == 1">{{contractStatusFormat2(customer.contractStatus)}}</van-tag>
                <van-tag round type="success" v-if="customer.contractStatus == 2">{{contractStatusFormat2(customer.contractStatus)}}</van-tag>
                <van-tag round type="danger" v-if="customer.contractStatus == 3">{{contractStatusFormat2(customer.contractStatus)}}</van-tag>
                <van-tag round type="warning" v-if="customer.contractStatus == 4">{{contractStatusFormat2(customer.contractStatus)}}</van-tag> -->
            </span>
            <van-icon name="edit" color="#f8df0d" size="20px" class="icon-edit" v-hasPermi="['cont:newContract:edit']" @click="edit"/>
            <van-icon name="delete" color="red" size="20px" class="icon-delete" v-hasPermi="['cont:newContract:remove']" @click="remove" />
          </div>
          <div style="margin-left:30px;color: #1989fa">【{{customer.businessTypeName}}】</div>
          <van-tabs v-model="active" style="margin-top:10px;">
            <van-tab title="基本信息">
              <div class="small_card" style="margin-top:10px;">
                <div class="item" >
                  <div class="card-box">
                    <div class="flex-1">
                       <span class="key">合同编号：</span>
                       <span class="value">{{ customer.contractNum }}</span>
                    </div>
                  </div>
                </div>
                <div class="item" >
                  <div class="card-box">
                    <div class="flex-1">
                      <span style="flex: 0.4" class="key">我方签约主体机构：</span>
                      <span style="flex: 0.6" class="value">{{customer.companyName}}</span>
                    </div>
                  </div>
                </div>
                <div class="item" >
                  <div class="card-box">
                    <div class="flex-1">
                      <span style="flex: 0.3" class="key">我方签约部门：</span>
                      <span style="flex: 0.7" class="value">{{ customer.deptName }}</span>
                    </div>
                  </div>
                </div>
                <div class="item" >
                  <div class="card-box">
                    <div class="flex-1">
                      <span style="flex: 0.3" class="key">我方签约人：</span>
                      <span style="flex: 0.8" class="value">{{ customer.userName }}</span>
                    </div>
                  </div>
                </div>
                <div class="item" >
                  <div class="card-box">
                    <div class="flex-1">
                      <span class="key">合同模板：</span>
                      <span class="value">{{formatHandel('templateType',customer.templateType)}}</span>
                    </div>
                    <div class="flex-1">
                      <span class="key">框架类型：</span>
                      <span class="value">{{formatHandel('frameType',customer.frameType)}}</span>
                    </div>
                  </div>
                </div>
                <div class="item" >
                  <div class="card-box">
                    <div class="flex-1">
                      <span class="key">垫款方式：</span>
                      <span class="value">{{formatHandel('payType',customer.payType)}}</span>
                    </div>
                    <div class="flex-1">
                      <span class="key">合同金额：</span>
                      <span class="value">{{ customer.contractMoney }}(元)</span>
                    </div>
                  </div>
                </div>
                <div class="item" >
                  <div class="card-box">
                    <div class="flex-1">
                      <span class="key">开票方式：</span>
                      <span class="value">{{formatHandel('invoicingMethod',customer.invoicingMethod)}}</span>
                    </div>
                    <div class="flex-1">
                      <span class="key">发票类型：</span>
                      <span class="value">{{formatHandel('invoiceType',customer.invoiceType)}}</span>
                    </div>
                  </div>
                </div>
                <div class="item" >
                  <div class="card-box">
                    <div class="flex-1">
                       <span class="key">执行时间：</span>
                       <span class="value">{{ customer.startTime }}至{{customer.endTime}}</span>
                    </div>
                  </div>
                </div>
                <div class="item" >
                  <div class="card-box">
                    <div class="flex-1">
                      <span style="flex: 0.4" class="key">我方签约主体地位：</span>
                      <span style="flex: 0.6" class="value">{{formatHandel('signedMainType',customer.signedMainType)}}</span>
                    </div>
                  </div>
                </div>
                <div v-if="isVendite">
                  <div class="item" >
                    <div class="card-box">
                      <div class="flex-1">
                        <span class="key">付款周期：</span>
                        <span class="value">{{customer.payCycle}}(天)</span>
                      </div>
                      <div class="flex-1">
                        <span class="key">媒介归属：</span>
                        <span class="value">{{formatHandel('mediaType',customer.mediaType)}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="item" >
                    <div class="card-box">
                      <div class="flex-1">
                        <span class="key">合作政策：</span>
                        <span class="value">{{formatHandel('cooperationPolicy',customer.cooperationPolicy)}}</span>
                      </div>
                      <div class="flex-1">
                        <span class="key">运营方式：</span>
                        <span class="value">{{formatHandel('operationMode',customer.operationMode)}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="item" v-if="customer.payType == '2'">
                    <div class="card-box">
                      <div class="flex-1">
                        <span class="key">用印日期：</span>
                        <span class="value">{{ customer.useSealTime }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="isVendite && customer.payType == '2'">
                  <div class="item" >
                    <div class="card-box">
                      <div class="flex-1">
                        <span style="flex: 0.3" class="key">授信周期类型：</span>
                        <span style="flex: 0.7" class="value">{{formatHandel('creditCycleType',customer.creditCycleType)}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="item" >
                    <div class="card-box">
                      <div class="flex-1">
                        <span style="flex: 0.3" class="key">授信周期时间：</span>
                        <span style="flex: 0.7" class="value">{{ customer.creditCycleValue }}(天)</span>
                      </div>
                    </div>
                  </div>
                  <div class="item" >
                    <div class="card-box">
                      <div class="flex-1">
                        <span class="key">回款账期：</span>
                        <span class="value">{{customer.collectionPeriod}}(天)</span>
                      </div>
                      <div class="flex-1">
                        <span class="key">授信金额：</span>
                        <span class="value">{{ customer.creditMoney}}(元)</span>
                      </div>
                    </div>
                  </div>
                  <div class="item" >
                    <div class="card-box">
                      <div class="flex-1">
                        <span class="key">垫款事由：</span>
                        <span class="value">{{ customer.advancesCycle }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item" >
                  <div class="card-box">
                    <div class="flex-1">
                      <span class="key">条款说明：</span>
                      <span class="value">{{ customer.content }}</span>
                    </div>
                  </div>
                </div>
                <!-- <div class="item" >
                   <div class="card-box" v-if="customer.contractSource === '2'">
                    <div class="flex-1">
                      <span class="key">回款金额：</span>
                      <span class="value">{{ customer.allReturnedMoney }}</span>
                    </div>
                    <div class="flex-1">
                      <span class="key">未回金额：</span>
                      <span class="value">{{ customer.noReturnedMoney }}</span>
                    </div>
                  </div>
                </div>
                <div class="card-box">
                    <div class="card-box" v-if="customer.contractType === 1">
                      <div class="flex-1">
                        <span class="key">业务类型：</span>
                        <span class="value">{{ customer.serviceTypeName }}</span>
                      </div>
                    </div>
                    <div class="card-box" v-if="customer.contractType === 1">
                      <div class="flex-1">
                        <span class="key">产品类型：</span>
                        <span class="value">{{ customer.businessTypeName }}</span>
                      </div>
                    </div>
                </div>
                <div class="item" v-if="customer.verifyStatus != '0'">
                    <div class="card-box">
                      <div class="flex-1">
                        <span class="key">审核人：</span>
                        <span class="value">{{ customer.reviewerName }}</span>
                      </div>
                      <div class="flex-1">
                        <span class="key">审核时间：</span>
                        <span class="value">{{ customer.reviewerTime }}</span>
                      </div>
                    </div>
                </div>
                <div class="item" v-if="customer.verifyStatus != '0'">
                    <div class="card-box">
                      <div class="flex-1">
                        <span class="key">审核状态：</span>
                        <span class="value">
                            <span v-if="customer.verifyStatus==0">待审核</span>
                            <span v-if="customer.verifyStatus==1">审核通过</span>
                            <span v-if="customer.verifyStatus==2">审核不通过</span>
                        </span>
                      </div>
                      <div class="flex-1">
                          <span class="key">审核意见：</span>
                          <span class="value">{{ customer.reviewerText }}</span>
                      </div>
                    </div>
                </div>
                 <div class="card-box" v-if="customer.verifyStatus != '0'">
                  <div class="flex-1">
                    <span class="key">归档状态：</span>
                    <span class="value">{{ contIsReturnFormat(customer.isReturn) }}</span>
                  </div>
                </div>   -->
              </div>
            </van-tab>
            <van-tab title="签约信息">
              <div class="item" style="margin-top:10px;">
                <div class="card-box">
                  <div class="flex-1">
                    <span style="flex: 0.3" class="key">信息提供部门：</span>
                    <span style="flex: 0.7" class="value">{{ customer.infoDeptName}}</span>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="card-box">
                  <div class="flex-1">
                    <span style="flex: 0.3" class="key">信息提供人：</span>
                    <span style="flex: 0.8" class="value">{{ customer.infoUserName}}</span>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="card-box">
                  <div class="flex-1">
                    <span style="flex: 0.3" class="key">对方签约人：</span>
                    <span style="flex: 0.8" class="value">{{ customer.signedUser }}</span>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="card-box">
                  <div class="flex-1">
                    <span style="flex: 0.4" class="key">对方签约人电话：</span>
                    <span style="flex: 0.7" class="value">{{ customer.signedUserMobile }}</span>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="card-box">
                  <div class="flex-1">
                    <span style="flex: 0.4" class="key">对方签约人邮箱：</span>
                    <span style="flex: 0.7" class="value">{{ customer.signedUserEmail }}</span>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="card-box">
                  <div class="flex-1">
                    <span style="flex: 0.4" class="key">对方签约人微信：</span>
                    <span style="flex: 0.7" class="value">{{ customer.signedUserWx }}</span>
                  </div>
                </div>
              </div>
              <div class="item" >
                <div class="card-box">
                  <div class="flex-1">
                    <span style="flex: 0.3" class="key">我方签约部门：</span>
                    <span style="flex: 0.7" class="value">{{ customer.deptName }}</span>
                  </div>
                </div>
              </div>
              <div class="item" >
                <div class="card-box">
                  <div class="flex-1">
                    <span style="flex: 0.3" class="key">我方签约人：</span>
                    <span style="flex: 0.8" class="value">{{ customer.userName }}</span>
                  </div>
                </div>
              </div>
              <div class="item" v-if="customer.templateType == 2">
                <div class="card-box">
                  <div class="flex-1">
                    <span style="flex: 0.3" class="key">申请用印日期：</span>
                    <span style="flex: 0.7" class="value">{{ customer.useSealTime }}</span>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="card-box">
                  <div class="flex-1">
                    <span class="key">交付日期：</span>
                    <span class="value">{{ customer.deliveryTime }}</span>
                  </div>
                  <div class="flex-1">
                    <span class="key">签约时间：</span>
                    <span class="value">{{ customer.signTime }}</span>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab title="附件信息">
              <div class="item">
                <van-list :finished="finished" finished-text="没有更多了"  @load="getContractFileList" v-if="contractFileList.length > 0">
                  <van-cell v-for="(item,index) in contractFileList" :key="index">
                    <div class="flex-between" v-if="item">
                      <div>
                          <div>
                            <span class="key"> 附件标题：</span>
                            <span class="value">{{ item.title }}</span>
                          </div>
                          <div>
                            <span class="key"> 附件类型：</span>
                            <span class="value">{{formatHandel('fileType',customer.fileType)}}</span>
                          </div>
                          <div v-if="item.amount">
                            <span class="key"> 变动金额：</span>
                            <span class="value">{{ item.amount }}(元)</span>
                          </div>
                          <div v-if="item.fileDesc">
                            <span class="key"> 附件描述：</span>
                            <span class="value">{{ item.fileDesc }}</span>
                          </div>
                      </div>
                      <div style="float: right;">
                        <!-- <van-button type="warning" style="margin-left:10px;" size="small" @click="editContFile(item.id)">修改</van-button>
                        <van-button type="danger" style="margin-left:10px;" size="small" @click="removeContFile(item.url,'电子附件')">删除</van-button>       -->
                        <a :href="item.url" @click="downloadUrlFile(item.url,item.title + '附件')">附件详情</a>
                      </div>
                    </div>
                  </van-cell>
                </van-list>
                <div v-if="contractFileList.length == 0" style="text-align:center;color:red;height:50px;line-height:50px;">暂无附件记录！</div>
              </div>
            </van-tab>
            <van-tab title="收款约定">
              <div class="item">
                <van-list :finished="finished" finished-text="没有更多了"  @load="getContPayAgreeList" v-if="contPayAgreeList.length > 0">
                  <van-cell v-for="(item,index) in contPayAgreeList" :key="index">
                    <div class="flex-between" v-if="item">
                      <div>
                          <div>
                            <span class="key"> 款项内容：</span>
                            <span class="value">{{formatHandel('contPayType',item.contPayType)}}</span>
                          </div>
                          <div>
                            <span class="key"> 付款日期：</span>
                            <span class="value">{{item.payTime}}</span>
                          </div>
                          <div>
                            <span class="key"> 付款单位：</span>
                            <span class="value">{{ item.custName }}</span>
                          </div>
                          <div>
                            <span class="key"> 收款合同方：</span>
                            <span class="value">{{ item.companyName }}</span>
                          </div>
                          <div v-if="item.entrustCustName">
                            <span class="key"> 委托付款单位：</span>
                            <span class="value">{{ item.entrustCustName }}</span>
                          </div>
                          <div>
                            <span class="key"> 付款条件：</span>
                            <span class="value">{{ item.payCondition }}</span>
                          </div>
                          <div v-if="item.contractMoney">
                            <span class="key"> 付款金额：</span>
                            <span class="value">{{ item.contractMoney }}(元)</span>
                          </div>
                      </div>
                    </div>
                  </van-cell>
                </van-list>
                <div v-if="contPayAgreeList.length == 0" style="text-align:center;color:red;height:50px;line-height:50px;">暂无收款约定！</div>
              </div>
            </van-tab>
          </van-tabs>
          <div class="link">
            <van-button class="linkaddBtn" size="small" round block type="info" v-if="customer.contractStatus==0 && customer.payType==1 && customer.templateType==2"
              @click="handleSpApply(customer)" v-preventReClick v-hasPermi="['cont:newContract:spApply']">用章申请</van-button>
            <van-button class="linkaddBtn" size="small" round block type="info" v-if="customer.contractStatus==0 && customer.payType==2"
              @click="handleDkApply(customer)" v-preventReClick v-hasPermi="['cont:newContract:spApply']">垫款申请</van-button>
          </div>

        <!-- <div class="title_name " v-if="customer.contractSource == '2'">
          {{ customer.contractName }}
        </div>
        <div class="card-box" v-else>
          <span class="key">合同标题：</span>
          <span class="value">{{ customer.contractName }}</span>
        </div> -->

      </div>
      <!-- <div class="card b-g-w payimg" v-if="customer.contractImg">
        <div class="imgList">
          <img v-for="item in captureList" :key="item" :src="item" class="img" alt="合同相片" @click="getImg(item)" />
        </div>
      </div>  -->

      <!--功能菜单 修改、审核通过、审核驳回-->
      <van-grid>
        <van-grid-item v-if="customer.verifyStatus == '0'">
          <div class="flex-center" v-hasPermi="['cont:contract:edit']">
            <van-icon name="edit" size="22" color="#07c160" />
            <span class="grid-span" @click="handleUpdate(customer)">修改</span>
          </div>
        </van-grid-item>
        <van-grid-item v-if="customer.verifyStatus == '0'">
        <div class="flex-center" v-hasPermi="['cont:contract:remove']">
          <van-icon name="delete-o" size="22" color="#f76f6c" />
          <span class="grid-span" @click="handleDelete(customer.contractId)">删除</span>
        </div>
        </van-grid-item>
        <van-grid-item v-if="customer.verifyStatus == '0'" v-hasPermi="['cont:contract:add']">
          <div class="flex-center">
            <van-icon name="label-o" size="22" color="green" />
            <span class="grid-span" @click="handleFileAdd">添加附件</span>
          </div>
        </van-grid-item>
        <van-grid-item v-if="customer.verifyStatus == '0' && this.pageStatus != 1" v-hasPermi="['cont:contract:reviewer']">
          <div class="flex-center">
            <van-icon name="success" size="22" color="#0080FF" />
            <span class="grid-span" @click="handleApply(customer)">审核</span>
          </div>
        </van-grid-item>
      </van-grid>
      <van-grid v-show="customer.verifyStatus === '1' && customer.isReturn === 1" v-hasPermi="['cont:contract:archive']">
      <van-grid-item>
          <div class="flex-center">
            <van-icon name="success" size="22" color="#0080FF" />
            <span class="grid-span" @click="handleReturn(customer)">归档</span>
          </div>
      </van-grid-item>
      </van-grid>

      <!--修改合同信息-->
      <van-dialog v-model="show" title="修改合同信息" width="95%" style="height:80%" class="editClue" :beforeClose="editContractBeforeClose" close-on-click-overlay>
        <van-form ref="form" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
          <van-cell-group>
            <van-field v-model="form.contractName" label="合同标题" placeholder="请输入合同标题" :rules="[{ required: true }]" required />
            <van-field v-model="form.contractNum" label="合同编号" placeholder="请输入合同编号" :rules="[{ required: true}]" required />
            <van-field readonly clickable v-model="form.boName" placeholder="请选择商机名称" @click="showPicker('boId')" label="商机名称" required />
            <van-field v-model="form.custName" label="客户名称" placeholder="请选择商机名称" :rules="[{ required: true }]" readonly required />
            <van-field v-model="form.contractMoney" label="合同金额(元)" placeholder="请输入合同金额" @input="getSum" :rules="[{ required: true }]" type="number" maxlength="15" required />
            <van-field v-model="form.allReturnedMoney" label="合同回款总金额(元)" placeholder="请输入合同回款总金额" @input="getSum" label-width="145px" type="number" maxlength="15" :rules="[{ required: true }]" required />
            <van-field v-model="form.noReturnedMoney" label="合同未回款金额(元)"  placeholder="未回款金额=合同金额-合同回款总金额" disabled label-width="145px" type="number" maxlength="15" :rules="[{ required: true }]"  />
            <van-field readonly clickable v-model="form.contractTypeName" @click="showPicker('contractType')" label="合同类型" required />
            <van-field readonly clickable v-model="form.contractStatusName" placeholder="请选择合同状态" @click="showPicker('contractStatus')" label="合同状态" />
            <van-field readonly clickable v-model="form.payModeName" placeholder="请选择支付方式" @click="showPicker('payMode')" label="支付方式" required />
            <van-field v-model="form.startTime" readonly clickable name="calendar" label="开始时间" placeholder="点击选择日期" @click="showStartCalendar = true" required />
            <van-field v-model="form.endTime" readonly clickable name="calendar" label="结束时间" placeholder="点击选择日期" @click="showEndCalendar = true" required />
            <van-field v-model="form.signTime" readonly clickable name="calendar" label="签约日期" placeholder="点击选择日期" @click="showSignCalendar = true" required />
            <van-field v-model="form.custSignedUser" label="对方签约人" placeholder="请填写对方签约人" :rules="[{ required: true }]" required />
            <van-field v-model="form.signedUserMobile" label="对方电话" placeholder="请填写对方电话" maxlength="11" :rules="mobileRules" required  />
            <van-field v-model="form.mySignedUser" label="我方签约人" placeholder="请填写我方签约人" :rules="[{ required: true}]" required />
            <!-- <van-field name="uploader" label="合同相片">
              <template #input>
                <van-uploader v-model="pictureList" :after-read="uploadContractPictureFiles" :before-read="beforeRead" :deletable="true" :before-delete="handleContractRemove" :max-count="9" :multiple="true" :max-size="52428800" upload-text="合同相片" />
              </template>
            </van-field>
            <van-field name="rate" label="电子合同">
              <template #input>
                <van-uploader v-model="fileList" :after-read="uploadContractFiles" :max-count="1" :max-size="52428800" upload-text="电子合同" required>
                </van-uploader>
              </template>
            </van-field>
            <van-field name="rate" label="附件1">
              <template #input>
                <van-uploader v-model="fileList1" :after-read="uploadContractFiles1" :max-count="1" :max-size="52428800" upload-text="附件1">
                </van-uploader>
              </template>
            </van-field>
            <van-field name="rate" label="附件2">
              <template #input>
                <van-uploader v-model="fileList2" :after-read="uploadContractFiles2" :max-count="1" :max-size="52428800" upload-text="附件2">
                </van-uploader>
              </template>
            </van-field> -->
            <van-field v-model="form.remark" label="备注" />
            <van-field v-model="form.content" rows="2" type="textarea" label="合同内容" />
          </van-cell-group>
        </van-form>
      </van-dialog>

      <!-- 日期选择器 -->
      <van-calendar v-model="showStartCalendar" :min-date="minDate" style="height:60%" type="single" @confirm="onStartCalendarConfirm" />
      <van-calendar v-model="showEndCalendar" :min-date="minDateStart" type="single" @confirm="onEndCalendarConfirm" />
      <van-calendar v-model="showSignCalendar" :min-date="minDate" type="single" @confirm="onSignCalendarConfirm" />
      <van-popup v-model="picker.visible" position="bottom">
        <van-picker :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" @change="pickerChange" />
      </van-popup>

       <!--添加合同附件-->
       <van-dialog v-model="contFile.show" :title="contFile.title" width="90%" :beforeClose="ContractFileBeforeClose" close-on-click-overlay>
        <van-form ref="contFileForm" validate-trigger="contFileFOnSubmit" class="dialog-form-wrap" style="height:98%;">
            <van-field v-model="contFileForm.title" label="附件标题" :rules="[{ required: true }]" required placeholder="请填写附件标题" />
            <van-field readonly clickable v-model="contFileForm.fileTypeName" @click="showPicker('contFileType')" label="附件类型" required placeholder="请选择附件类型" />
            <van-field v-model="contFileForm.amount" label="变动金额(元)" placeholder="请填写变动金额" />
            <van-field name="rate" label="附件">
              <template #input>
                <van-uploader :file-list="fileList" :before-read="beforeRead" :after-read="afterRead" :before-delete="handleDeletImg"  :max-count="10"  />

                <!-- <van-uploader v-model="fileList" :after-read="uploadContractFiles" :before-read="beforeRead" :deletable="true" :before-delete="handleContractFileRemove" :max-count="10" :max-size="52428800" upload-text="电子附件" /> -->
              </template>
            </van-field>
            <van-field v-model="contFileForm.fileDesc" rows="2" type="textarea" label="附件描述" />
            <van-field v-model="contFileForm.remark" label="备注" />

        </van-form>
       </van-dialog>

       <!-- 审核表单 -->
    <van-dialog v-model="auditOpen" title="合同审批" :beforeClose="submitApply" close-on-click-overlay>
      <br/>
      <van-form ref="auditForm" validate-trigger="onSubmit" >
          <van-field name="radio" label="审核状态" prop="verifyStatus" :rules="[{ required: true }]">
            <template #input>
              <van-radio-group v-model="auditForm.verifyStatus" direction="horizontal"  >
                <van-radio name="1">通过</van-radio>
                <van-radio name="2">不通过</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field v-model="auditForm.reviewerText" label="审核意见" type="textarea" placeholder="请填写审核意见" />
      </van-form>
    </van-dialog>

    </div>
  </div>
</template>

<script>
// import pdf from 'vue-pdf'
import moment from 'moment'
import {
  List,
  Cell,
  Button,
  Tag,
  Dialog,
  Area,
  Toast,
  Divider,
  Icon,
  Field,
  Col,
  Row,
  CellGroup,
  Popup,
  Picker,
  Radio,
  RadioGroup,
  Grid,
  GridItem,
  Uploader,
  ImagePreview,
  Image,
  Form,
  Calendar
} from 'vant'
import { getNoContract, updateNoContract, verifyContract } from '@/api/cont/nocontract'
import { getFailContract, updateFailContract } from '@/api/cont/failcontract'
import { getContract, reviewer, updateContract } from '@/api/cont/contract'
import { getNoInvoiceContract } from '@/api/fina/noinvoice'
import { selectAllBusinessType } from '@/api/scrm/custbusinesstype'
import newContract from '@/api/cont/newContract'
import { getDicts } from '@/api/system/dict/data'
import {
  addOtherContract,
  getOtherContract,
  updateOtherContract,
  delOtherContract
} from '@/api/cont/othercontract'
import { getNonBusinessContract, delnonContract, updateNonContract } from '@/api/cont/nonbusinesscontract'
import { selectAllCustLevel } from '@/api/scrm/custlevel'
import { areaList } from '@vant/area-data'
import { uploadFile, deleteFile, ucloudUpFileToContract, deleteFileToUcloud } from '@/api/system/common'
// import { contFileList, getContFile, delContFile, addContFile, updateContFile, exportContFile } from "@/api/cont/ContractFile";

import {
  queryListContact,
  listContact,
  getContact,
  addContact,
  updateContact
} from '@/api/scrm/custcontact'
// import { queryListVisit } from "@/api/scrm/custvisit";
import { error } from 'weixin-js-sdk'
import { getDict } from '@/utils/dict'

export default {
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Popup.name]: Popup,
    [Divider.name]: Divider,
    [Picker.name]: Picker,
    [Area.name]: Area,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Uploader.name]: Uploader,
    [Image.name]: Image,
    [Form.name]: Form,
    [Calendar.name]: Calendar,
    [ImagePreview.Component.name]: ImagePreview.Component
    // pdf
  },
  filters: {
    timeFormat(val) {
      if (val != null && val.length > 0) {
        return moment(val).format('YYYY-MM-DD')
      }
    }
  },
  metaInfo: {
    //  这里是给页面修改
    title: '',
    meta: [
      { charset: 'utf-8' },
      {
        name: 'viewport',
        content:
          'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=2,user-scalable=yes'
      }
    ]
  },
  data() {
    return {
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        areaList
      },
      isVendite: false, // 是否是 销售/数字技术类
      options: [],
      loading: false,
      finished: false,
      active: 0,
      // 合同附件添加框
      contFile: {
        show: false,
        title: ''
      },
      // 合同附件
      contractFileList: [],
      // 收款约定
      contPayAgreeList: [],
      pdfSrc: '', // pdf文件地址
      numPages: 0,
      customer: {},
      // 合同审核
      auditOpen: false,
      // 提单参数
      orderForm: {},
      // listVisit: [],
      // 地区树选项
      areaOptions: [],
      // 行业树选项
      industryOptions: [],
      // auditFormRules: {
      //   verifyStatus: [
      //     { required: true, message: "审核不通过时意见必填", trigger: "blur" }
      //   ]
      // },
      // 客户回访类型
      custVisitTypeOptions: this.$store.state.dictOptions.custVisitType || [],
      // 商机状态
      boStatusOptions: this.$store.state.dictOptions.custBoStatus || [],
      // 客户联系人列表
      custContactOptions: [],
      // 客户来源字典
      custSourceOptions: this.$store.state.dictOptions.custSource || [],
      // 客户等级
      // custLevelOptions: [],
      // 客户类型
      custTypeOptions: this.$store.state.dictOptions.crmCustType || [],
      // 投放类型列表
      launchTypeOptions: this.$store.state.dictOptions.custOrderLaunchType || [],
      // 产品类型列表
      businessTypeOptions: this.$store.state.dictOptions.businessTypeTree || [],
      // 业务类型树选项
      serviceTypeTreeOptions: this.$store.state.dictOptions.serviceTypeTree || [],
      // 合同状态
      contractStatusOptions: this.$store.state.dictOptions.contractStatus || [],
      // 合同类型
      contractTypeOptions: this.$store.state.dictOptions.contractType || [],
      // 支付方式
      payModeOptions: this.$store.state.dictOptions.payMode || [],
      // 合同附件类型
      contFileTypeOptions: this.$store.state.dictOptions.contFileType || [],
      // 合同归档状态
      contIsReturnOptions: this.$store.state.dictOptions.contIsReturn || [],
      mobileRules:
      [{
        required: true,
        message: '手机号码不能为空',
        trigger: 'onBlur'
      },
      {
        // 自定义校验规则
        validator: value => {
          return /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/
            .test(value)
        },
        message: '请输入正确格式的手机号码',
        trigger: 'onBlur'
      }],
      fileList: [],
      fileList1: [],
      fileList2: [],
      deleteFileList: [],
      captureList: [],
      pictureList: [],
      show: false,
      order: false,
      other: false,
      readFiles: false,
      isInvoice: false,
      pageStatus: 0,
      readTitle: '',
      showStartCalendar: false,
      showEndCalendar: false,
      showSignCalendar: false,
      minDate: new Date(2010, 0, 1),
      minDateStart: new Date(2010, 0, 1),
      contFileForm: {
        id: null,
        contractId: null,
        title: '',
        fileType: null,
        url: '',
        amount: null,
        fileDesc: ''
      },
      form: {
        contractId: null,
        custOrderId: null,
        contractNum: null,
        contractName: null,
        custId: null,
        custName: null,
        contractSource: null,
        contractType: null,
        contractStatus: null,
        businessTypeName: null,
        businessType: null,
        payMode: null,
        contractTypeName: null,
        contractStatusName: null,
        payModeName: null,
        hkStatus: null,
        verifyStatus: null,
        contractMoney: null,
        allReturnedMoney: null,
        noReturnedMoney: null,
        startTime: null,
        endTime: null,
        signedUserMobile: null,
        custSignedUser: null,
        mySignedUser: null,
        signTime: null,
        contractImg: null,
        contractFile: null,
        annexOne: null,
        annexTwo: null,
        content: null,
        readerCount: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: '0',
        delFlag: null,
        remark: null
      },
      // 回访记录
      visitForm: {
        content: null,
        visitType: null,
        custId: null,
        custName: null,
        contactId: null,
        contactName: null
      },
      // 客户联系人查询条件
      queryContactParams: {
        pageNum: 1,
        pageSize: 100,
        contactId: null,
        contactName: null,
        custId: null,
        custName: null
      },
      queryContFileParams: {
        contactId: null
      },
      auditForm: {
        verifyStatus: '1',
        ids: []
      }
    }
  },
  created() {
    this.getOptions()
    const flag = this.$store.state.dictOptions
    if (flag && flag.contractStatus.length > 0) {} else {
      getDict()
    }
  },
  mounted() {
    // this.getCustLevelList();
    this.init()
    // this.queryListVisit();
  },
  methods: {
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    getOptions() {
      // 媒介归属
      getDicts('media_type').then(res => {
        this.options.mediaTypeOptions = res.data
      })
      // 合作政策
      getDicts('cooperation_policy').then(res => {
        this.options.cooperationPolicyOptions = res.data
      })
      // 运营方式
      getDicts('operation_mode').then(res => {
        this.options.operationModeOptions = res.data
      })
      // 开票方式
      getDicts('Invoicing_method').then(res => {
        this.options.invoicingMethodOptions = res.data
      })
      // 发票类型
      getDicts('Invoice_type').then(res => {
        this.options.invoiceTypeOptions = res.data
      })
      // 我方主体地址
      getDicts('signed_main_type').then(res => {
        this.options.signedMainTypeOptions = res.data
      })
      // 合同模板
      getDicts('template_type').then(res => {
        this.options.templateTypeOptions = res.data
      })
      // 框架类型
      getDicts('frame_type').then(res => {
        this.options.frameTypeOptions = res.data
      })
      // 客户来源类型
      getDicts('cust_source').then(res => {
        this.options.custSourceOptions = res.data
      })
      // 垫款方式
      getDicts('pay_type').then(res => {
        this.options.payTypeOptions = res.data
      })
      // 付款类型
      getDicts('cont_pay_type').then(res => {
        this.options.contPayTypeOptions = res.data
      })
      // 附件类型
      getDicts('file_type').then(res => {
        this.options.fileTypeOptions = res.data
      })
      // 授信周期类型
      getDicts('credit_cycle_type').then(res => {
        this.options.creditCycleTypeOptions = res.data
      })
    },
    getSum() {
      const contractMoeny = this.form.contractMoney || 0
      const allReturnedMoney = this.form.allReturnedMoney || 0
      const total = contractMoeny - allReturnedMoney
      this.form.noReturnedMoney = total.toFixed(2)
    },
    async init() {
      // 修改主体框架标题
      document.title = 'CONT-合同详情'

      const { id, verifyStatus, contractSource, contractType, isInvoice, status } = this.$route.query
      this.isInvoice = isInvoice
      this.visitForm.contractId = id
      this.contFileForm.contractId = id
      this.queryContFileParams.contractId = id
      // this.queryContactParams.contractId = id;
      this.pageStatus = status
      const res = await newContract.getContract(id)

      // if (contractSource == "2") {
      //   if (contractType === "2") {
      //     res = await getNonBusinessContract(id);
      //   } else {
      //     res = await getOtherContract(id);
      //   }

      // } else if (verifyStatus == "0") {
      //   res = await getNoContract(id);
      // } else if (verifyStatus == "1") {
      //   if (this.isInvoice) {
      //     res = await getNoInvoiceContract(id);
      //   } else {
      //     res = await getContract(id);
      //   }
      // } else if (verifyStatus == "2") {
      //   res = await getFailContract(id);
      // }
      if (res.code === 200) {
        this.customer = res.data
        const name = res.data.businessTypeName.split('/')
        if (name[0] == '销售' && name[1] == '数字技术类') {
          this.isVendite = false
        } else {
          this.isVendite = true
        }
        if (this.customer.contractImg != null && this.customer.contractImg.length > 0) {
          this.captureList = this.customer.contractImg.split(',')
        }
      }
      await this.getContractFileList()
      await this.getContPayAgreeList()
    },
    // 获取合同附件列表
    async getContractFileList() {
      newContract.listContractFile(this.queryContFileParams).then(response => {
        this.contractFileList = response.rows
      })
    },
    // 获取收款约定列表
    async getContPayAgreeList() {
      newContract.listPayAgree(this.queryContFileParams).then(response => {
        this.contPayAgreeList = response.rows
      })
    },
    contractTypeFormat2(contractType) {
      const label = this.selectDictLabel(this.contractTypeOptions, contractType)
      if (label) {
        return label
      } else {
        if (contractType == 6) {
          return '2022销售合同'
        } else {
          return ''
        }
      }
    },
    contFileTypeFormat(contFileType) {
      return this.selectDictLabel(this.contFileTypeOptions, contFileType)
    },
    contIsReturnFormat(isReturn) {
      return this.selectDictLabel(this.contIsReturnOptions, isReturn)
    },
    contractStatusFormat2(contractStatus) {
      return this.selectDictLabel(this.contractStatusOptions, contractStatus)
    },
    // 支付方式字典翻译
    payModeFormat2(payMode) {
      return this.selectDictLabel(this.payModeOptions, payMode)
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    },
    onStartCalendarConfirm(data) {
      this.contractForm.startTime = this.formatDate(data)
      this.showStartCalendar = false
      this.minDateStart = data
    },
    onEndCalendarConfirm(data) {
      this.form.endTime = this.formatDate(data)
      this.showEndCalendar = false
    },
    onSignCalendarConfirm(data) {
      this.form.signTime = this.formatDate(data)
      this.showSignCalendar = false
    },
    // getNumPages(url) {
    //   let loadingTask = pdf.createLoadingTask(url)
    //   loadingTask.promise.then(pdf => {
    //     this.numPages = pdf.numPages
    //   }).catch(err => {
    //     console.error('pdf 加载失败', err);
    //   })
    // },
    // 返回布尔值
    // beforeRead(file) {
    //   if (
    //     file.type !== "image/jpeg" &&
    //     file.type !== "image/png" &&
    //     file.type !== "image/jpg"
    //   ) {
    //     Toast("请上传 jpg 、jpeg、png 格式图片");
    //     return false;
    //   }
    //   return true;
    // },
    beforeRead(file) {
      if (file instanceof Array) {
        // 判断是否是数组
        file.forEach((v) => {
          this.checkFile(v)
        })
      } else {
        this.checkFile(file)
      }
      return true
    },
    // 图片类型检查
    checkFile(file) {
      const format = ['jpg', 'png', 'jpeg']
      const index = file.name.lastIndexOf('.')
      const finalName = file.name.substr(index + 1)
      if (!format.includes(finalName.toLowerCase())) {
        Toast('请上传' + format.join(',') + '格式图片')
        return false
      }
    },
    afterRead(file) {
      const This = this
      if (Array.isArray(file)) {
        file.forEach(item => {
          item.status = 'uploading'
          item.message = '上传中...'
          This.uploadMaterialImg(item)
        })
      } else {
        file.status = 'uploading'
        file.message = '上传中...'
        this.uploadMaterialImg(file)
      }
    },
    handleDeletImg(item) {
      this.fileList = this.fileList.filter((v) => v.url != item.url)
    },
    async uploadMaterialImg(file) {
      const This = this
      const _file = file.file
      // 通过 FormData 对象上传文件
      var formData = new FormData()
      formData.append('file', _file)
      uploadFile(formData).then(res => {
        if (res.code == 200) {
          this.fileList.push({ url: res.url })
          file.status = 'done'
          file.message = '上传成功'
        } else {
          This.$toast('照片上传失败，请重新上传！')
        }
      }).catch(error => {
        file.status = 'failed'
        file.message = '上传失败'
        This.$toast('照片上传失败，请重新上传！')
      })
      this.contFileForm.url = this.fileList.join(',')
    },
    // 返回布尔值
    beforeFileRead(file) {
      if (file.type !== 'pdf') {
        Toast('请上传 pdf 格式图片')
        return false
      }
      return true
    },
    // 获取客户等级名称———详情显示时
    // custLevelFormat2(custLevelId) {
    //   if (this.custLevelOptions != null) {
    //     let obj = this.custLevelOptions.find(
    //       (item) => item.custLevelId === custLevelId
    //     );
    //     if (obj != null) {
    //       return obj.levelName;
    //     }
    //   }
    // },
    saveAs(data, name) {
      const urlObject = window.URL || window.webkitURL || window
      const export_blob = new Blob([data])
      const save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a')
      save_link.href = urlObject.createObjectURL(export_blob)
      save_link.download = name + '.pdf'
      save_link.click()
    },
    downloadUrlFile(url, fileName) {
      const url2 = url.replace(/\\/g, '/')
      const xhr = new XMLHttpRequest()
      xhr.open('GET', url2, true)
      xhr.responseType = 'blob'
      // xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
      // 为了避免大文件影响用户体验，建议加loading
      xhr.onload = () => {
        if (xhr.status === 200) {
          // 获取文件blob数据并保存
          this.saveAs(xhr.response, fileName)
        }
      }
      xhr.send()
    },
    getImg(images) {
      ImagePreview({
        images: [images],
        showIndex: false,
        loop: false
      })
    },
    getNumPages(url) {
      var loadingTask = pdf.createLoadingTask(url)
      // this.pdfSrc = pdf.createLoadingTask(url)
      loadingTask.promise.then((pdf) => {
        this.pdfSrc = loadingTask
        this.numPages = pdf.numPages
      })
    },
    /** 转换产品类型数据结构 */
    businessNormalizer(node) {
      const arr = []
      if (node.children && node.children.length) {
        for (const i in node.children) {
          const item = {
            id: node.children[i].businessTypeId,
            text: node.children[i].businessTypeName
          }
          arr.push(item)
        }
      }
      return {
        id: node.businessTypeId,
        text: node.businessTypeName,
        children: arr
      }
    },
    /** 转换业务类型数据结构 */
    serviceNormalizer(node) {
      const arr = []
      if (node.children && node.children.length) {
        for (const i in node.children) {
          const item = {
            id: node.children[i].serviceTypeId,
            text: node.children[i].serviceTypeName
          }
          arr.push(item)
        }
      }
      return {
        id: node.serviceTypeId,
        text: node.serviceTypeName,
        children: arr
      }
    },
    // 获取用户等级
    // getCustLevelList() {
    //   selectAllCustLevel(null).then((response) => {
    //     this.custLevelOptions = response.data;
    //   });
    // },
    // 获取客户联系人记录列表
    // getCustContactList(custId) {
    //   //选择客户时获取该客户的联系人对象
    //   this.queryContactParams.custId = custId;
    //   queryListContact(this.queryContactParams).then((response) => {
    //     this.custContactOptions = response.data;

    //   });
    // },
    // async queryListVisit() {
    //   const res = await queryListVisit({ custId: this.$route.params.id });
    //   console.log(res);
    //   if (res.code === 200) {
    //     this.listVisit = res.data;
    //   }
    // },
    handleContractFileRemove(file) {
      let picture = this.contFileForm.contractImg
      console.log(file.url)
      if (picture.indexOf(file.url) == 0) {
        if (picture.indexOf(',') == -1) {
          picture = null
        } else {
          picture = picture.replace(file.url + ',', '')
        }
      } else {
        picture = picture.replace(',' + file.url, '')
      }
      this.contFileForm.contractImg = picture
      console.log(this.contFileForm.contractImg)
      this.pictureList = []
      if (this.contFileForm.contractImg != null && this.contFileForm.contractImg.length > 0) {
        const payCaptures = this.contFileForm.contractImg.split(',')
        payCaptures.forEach((element) => {
          this.pictureList.push({
            url: element
          })
        })
      }
      this.deleteFileList.push(file.url)

      // console.log("file:" + file.url);
      // let picture =this.contFileForm.contractImg;
      // if (picture.indexOf(file.url) == 0) {
      //   if (picture.indexOf(",") == -1) {
      //     picture = null;
      //   } else {
      //     picture = picture.replace(file.url + ",", "");
      //   }
      // } else {
      //   picture = picture.replace("," + file.url, "");
      // }
      // this.contFileForm.contractImg = picture;
      // this.fileList = [];
      // console.log("2");
      // if (this.contFileForm.contractImg != null && this.contFileForm.contractImg.length > 0) {
      //   let payCaptures = this.contFileForm.contractImg.split(",");
      //   payCaptures.forEach((element) => {
      //     this.fileList.push({
      //       url: element,
      //     });
      //   });
      // }
      // this.deleteFileList.push(file.url);
    },
    uploadContractPictureFiles(file) {
      console.log(file)
      const _file = file.file
      // 通过 FormData 对象上传文件
      var formData = new FormData()
      formData.append('file', _file)

      ucloudUpFileToContract(formData)
        .then((res) => {
          console.log('_RequestUploads_', res)
          if (res.code === 200) {
            // this.form.contractImg = res.url;
            let picture = this.form.contractImg
            if (picture != null && picture.length > 0) {
              picture += ',' + res.url
            } else {
              picture = res.url
            }
            this.form.contractImg = picture
            const payCaptures = this.form.contractImg.split(',')
            this.pictureList = []
            payCaptures.forEach((element) => {
              this.pictureList.push({
                url: element
              })
            })
            Toast.success(res.msg)
          } else {
            Toast.fail('res.msg')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    uploadContractFiles(file) {
      const _file = file.file
      // 通过 FormData 对象上传文件
      var formData = new FormData()
      formData.append('file', _file)
      uploadFile(formData).then((res) => {
        if (res.code === 200) {
          // this.form.contractImg = res.url;
          let picture = this.contFileForm.contractImg
          if (picture != null && picture.length > 0) {
            picture += ',' + res.url
          } else {
            picture = res.url
          }
          this.contFileForm.contractImg = picture
          const payCaptures = this.contFileForm.contractImg.split(',')
          this.pictureList = []
          payCaptures.forEach((element) => {
            this.pictureList.push({
              url: element
            })
          })
          Toast.success(res.msg)
        } else {
          Toast.fail('res.msg')
        }
      })
        .catch(function (error) {
          console.log(error)
        })

      //   if (res.code === 200) {
      //     this.contFileForm.url = res.url;
      //     Toast.success("上传成功");
      //   } else {
      //     Toast.fail("上传失败");
      //   }
      // })
      // .catch(function (error) {
      //   console.log(error);
      // });
    },
    /** 添加附件 */
    handleFileAdd() {
      this.contFile.show = true
      if (this.contFileForm.id == null) {
        this.contFile.title = '添加合同附件'
      } else {
        this.contFile.title = '修改合同附件'
      }
    },
    // 合同审核按钮
    handleApply(item, type) {
      this.auditForm.contractId = this.customer.contractId
      this.auditOpen = true
    },
    // 合同归档
    handleReturn(item, type) {
      this.auditForm.contractId = this.customer.contractId
      this.auditForm.verifyStatus = ''
      this.auditForm.isReturn = 2
      const that = this
      Dialog.confirm({
        title: '归档确认提示',
        message: '是否确认归档合同标题为"' + item.contractName + '"的数据项?'
      }).then(function() {
        return updateContract(that.auditForm)
      }).then(() => {
        this.init()
        that.auditOpen = false
        Toast.success('归档成功')
      }).catch(() => {})
    },
    // 合同审核
    submitApply(type, done) {
      const that = this
      if (type === 'confirm') {
        try {
          Dialog.confirm({
            title: '审核提示',
            message: '是否确认审核？'
          }).then(function() {
            return reviewer(that.auditForm)
          }).then(() => {
            this.init()
            that.auditOpen = false
            Toast.success('审核成功')
          }).catch(() => {})
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    /** 删除按钮操作 */
    handleDelete(contractId) {
      const verifyStatus = this.customer.verifyStatus
      const contractSource = this.customer.contractSource
      const contractType = this.customer.contractType
      Dialog.confirm({
        title: '警告',
        message: '是否确认删除【合同】ID为"' + contractId + '"的数据项?'
      }).then(
        function () {
          const api = contractType === 2 ? delnonContract : delOtherContract
          return api(contractId)
        }).then(() => {
        Toast.success('删除成功')
        if (contractSource == '2') {
          const path = contractType === '2' ? '/cont/nonbusiness/index'
            : contractType === '6' ? '/cont/sale2022/index' : '/cont/othercontract/index'
          this.$router.push({ path })
        } else if (verifyStatus == '0') {
          this.$router.push({ path: '/cont/nocontract/index' })
        } else if (verifyStatus == '1') {
          this.$router.push({ path: '/cont/contract/index' })
        } else if (verifyStatus == '2') {
          this.$router.push({ path: '/cont/failcontract/index' })
        }
      })
        .catch(() => { })
    },
    /** 审核通过按钮操作 */
    handleSuccess(customer) {
      const contract = {
        contractId: customer.contractId,
        verifyStatus: '1'
      }
      Dialog.confirm({
        title: '警告',
        message: '是否确认审核通过【合同】ID为"' + customer.contractId + '"的数据项?'
      }).then(
        function () {
          return verifyContract(contract)
        }).then(() => {
        Toast.success('审核通过')
        this.$router.push({ path: '/cont/contract/index' })
      })
        .catch(() => { })
    },
    /** 审核驳回按钮操作 */
    handleFail(customer) {
      const contract = {
        contractId: customer.contractId,
        verifyStatus: '2'
      }
      Dialog.confirm({
        title: '警告',
        message: '是否确认审核驳回【合同】ID为"' + customer.contractId + '"的数据项?'
      }).then(
        function () {
          return verifyContract(contract)
        }).then(() => {
        Toast.success('审核驳回')
        this.$router.push({ path: '/cont/failcontract/index' })
      })
        .catch(() => { })
    },
    // 客户回访记录重置
    orderFormReset() {
      this.orderForm = {
        paymentMoney: null,
        serviceFee: null,
        adFee: null,
        launchType: null,
        businessType: null,
        payCapture: null,
        content: null
      }
      // this.resetForm("orderForm");
    },
    // 修改合同
    async editContractBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          if (this.form.allReturnedMoney && this.form.contractMoney &&
            parseFloat(this.form.allReturnedMoney) > parseFloat(this.form.contractMoney)) {
            Toast.fail('合同回款金额不能大于合同金额！')
            return done(false)
          }
          await this.$refs.form.validate()
          if (this.form.contractSource == '2') {
            const api = this.form.contractType === '2' ? updateNonContract : updateOtherContract
            api(this.form).then((response) => {
              Toast.success('修改成功')
              this.show = false
              if (this.deleteFileList.length > 0) {
                deleteFile(this.deleteFileList)
              }
              this.init()
            })
          } else if (this.form.verifyStatus == '2') {
            updateFailContract(this.form).then((response) => {
              Toast.success('修改成功')
              this.show = false
              if (this.deleteFileList.length > 0) {
                deleteFile(this.deleteFileList)
              }
              this.init()
            })
          } else if (this.form.verifyStatus == '0') {
            updateNoContract(this.form).then((response) => {
              Toast.success('修改成功')
              this.show = false
              if (this.deleteFileList.length > 0) {
                deleteFileToUcloud(this.deleteFileList)
              }
              this.init()
            })
          }
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    edit() {
      this.$router.push('/cont/contract/add?contractId=' + this.customer.contractId)
    },
    async remove() {
      Dialog.confirm({
        message: '是否确认删除此条数据'
      })
        .then(() => {
          this.delete()
        })
        .catch(() => {
        // on cancel
        })
    },
    async delete() {
      const res = await newContract.deleteContract(this.customer.contractId)
      if (res.code === 200) {
        await Toast.success('成功删除!')
        setTimeout(() => {
          this.$router.go(-1)
        }, 500)
      }
    },
    // 用章申请
    async handleSpApply(row) {
      console.log(row)
      console.log(this.contractFileList)

      if (this.contractFileList.length == 0) {
        Toast.fail('请先填写合同附件信息!')
        return
      }
      const obj = { contractId: row.contractId }
      newContract.spApply(obj).then(response => {
        Toast.success('用章申请成功!')
        this.init()
      })
    },
    // 垫款申请
    handleDkApply(row) {
      if (this.contractFileList.length == 0) {
        Toast.fail('请先填写合同附件信息!')
        return
      }
      const obj = { contractId: row.contractId }
      newContract.dkApply(obj).then(response => {
        Toast.success('垫款申请成功')
        this.init()
      })
    },
    // 合同附件添加/修改
    async ContractFileBeforeClose(type, done) {
      if (type === 'confirm') {
        var itemUrl = []
        this.fileList.forEach((item) => {
          itemUrl.push(item.url)
        })
        this.contFileForm.url = itemUrl.join(',')
        try {
          await this.$refs.contFileForm.validate()
          if (this.contFileForm.id == null) {
            addContFile(this.contFileForm).then((response) => {
              this.contFile.show = false
              this.active = 2
              this.getContractFileList()
              Toast.success('添加成功')
            })
          } else {
            updateContFile(this.contFileForm).then((response) => {
              this.getContractFileList()
              Toast.success('修改成功')
              this.contFile.show = false
            })
          }
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    // 修改附件按钮
    editContFile(id) {
      getContFile(id).then(response => {
        this.contFileForm = response.data
        this.contFileForm.fileTypeName = this.contFileTypeFormat(this.contFileForm.fileType)
        if (this.contFileForm.url) {
          if (this.contFileForm.url.indexOf('jpg') >= 0 || this.contFileForm.url.indexOf('png') >= 0) {

          }
        }
        this.contFile.show = true
        this.contFile.title = '修改合同附件'
      })
      // getContFile(id).then(response => {
      //   console.log("data:" + response.rows);

      //   this.contFileForm = response.rows;
      //
      // });
    },
    submitUpdate() {
      if (this.form.contractSource == '2') {
        const api = this.form.contractType === '2' ? updateNonContract : updateOtherContract
        api(this.form).then((response) => {
          Toast.success('修改成功')
          this.show = false
          this.init()
        })
      } else if (this.form.verifyStatus == '2') {
        updateFailContract(this.form).then((response) => {
          Toast.success('修改成功')
          this.show = false
          this.init()
        })
      } else if (this.form.verifyStatus == '0') {
        updateNoContract(this.form).then((response) => {
          Toast.success('修改成功')
          this.show = false
          this.init()
        })
      }
    },
    addVisit() {
      this.visitForm = []
      this.show = true
    },
    showPicker(type) {
      this.picker.formKey = type
      if (type === 'contractType') {
        this.picker.columns = this.contractTypeOptions.map(
          (ele) => ele.dictLabel
        )
      }
      if (type === 'contractStatus') {
        this.picker.columns = this.contractStatusOptions.map(
          (ele) => ele.dictLabel
        )
      }
      if (type === 'businessTypeId') {
        this.picker.columns = this.businessTypeOptions.map(ele => this.businessNormalizer(ele))
      }
      if (type === 'serviceTypeId') {
        this.serviceTypeTreeOptions = this.serviceTypeTreeOptions ? this.serviceTypeTreeOptions : this.$store.state.dictOptions.serviceTypeTree
        this.picker.columns = this.serviceTypeTreeOptions.map(ele => this.serviceNormalizer(ele))
      }
      if (type === 'payMode') {
        this.picker.columns = this.payModeOptions.map((ele) => ele.dictLabel)
      }
      // 合同类型
      if (type === 'contFileType') {
        this.picker.columns = this.contFileTypeOptions.map((ele) => ele.dictLabel)
      }

      this.picker.visible = true
    },
    pickerConfirm(value, index) {
      if (this.picker.formKey === 'contractType') {
        this.form.contractType = this.contractTypeOptions[index].dictValue
        this.form.contractTypeName = this.contractTypeOptions[index].dictLabel
      }
      if (this.picker.formKey === 'contractStatus') {
        this.form.contractStatus = this.contractStatusOptions[index].dictValue
        this.form.contractStatusName =
          this.contractStatusOptions[index].dictLabel
      }
      if (this.picker.formKey === 'payMode') {
        this.form.payMode = this.payModeOptions[index].dictValue
        this.form.payModeName = this.payModeOptions[index].dictLabel
      }
      // 合同类型
      if (this.picker.formKey === 'contFileType') {
        this.contFileForm.fileType = this.contFileTypeOptions[index].dictValue
        this.contFileForm.fileTypeName = this.contFileTypeOptions[index].dictLabel
      }

      // 产品类型
      if (this.picker.formKey === 'businessTypeId') {
        if (value.length == 2) {
          if (value[1].length > 0) {
            this.form.businessTypeName = value[0] + '/' + value[1]
            const obj = this.businessTypeOptions.find(item => item.businessTypeName === value[0])
            if (obj != null) {
              this.form.businessType = obj.children.find(item => item.businessTypeName === value[1]).businessTypeId
            }
          }
        } else {
          this.form.businessTypeName = value[0]
          const obj = this.businessTypeOptions.find(item => item.businessTypeName === value[0])
          if (obj != null) {
            this.form.businessType = obj.businessTypeId
          }
        }
      }
      // 业务类型
      if (this.picker.formKey === 'serviceTypeId') {
        if (value.length == 2) {
          if (value[1].length > 0) {
            this.form.serviceTypeName = value[0] + '/' + value[1]
            const obj = this.serviceTypeTreeOptions.find(item => item.serviceTypeName === value[0])
            if (obj != null) {
              this.form.serviceTypeId = obj.children.find(item => item.serviceTypeName === value[1]).serviceTypeId
            }
          }
        } else {
          this.form.serviceTypeName = value[0]
          const obj = this.serviceTypeOptions.find(item => item.serviceTypeName === value[0])
          if (obj != null) {
            this.form.serviceTypeId = obj.serviceTypeId
          }
        }
      }
      this.picker.visible = false
    },

    pickerCancel() {
      this.picker.visible = false
    },
    readContractFiles(contractFiles) {
      // 微软提供的方法
      window.open(contractFiles)
    },
    pickerChange() { },
    handleUpdate(customer) {
      this.reset()
      this.fileList = []
      this.fileList1 = []
      this.fileList2 = []
      this.pictureList = []
      this.deleteFileList = []
      const contractId = customer.contractId
      const contractSource = customer.contractSource
      const verifyStatus = customer.verifyStatus
      if (contractSource == '2') {
        const api = customer.contractType === '2' ? getNonBusinessContract : getOtherContract
        api(contractId).then((response) => {
          this.form = response.data
          if (this.form.contractImg != null && this.form.contractImg.length > 0) {
            const contractImgs = this.form.contractImg.split(',')
            contractImgs.forEach(element => {
              this.pictureList.push({
                url: element
              })
            })
          }
          this.forField()
          this.show = true
        })
      } else if (verifyStatus == '0') {
        getNoContract(contractId).then((response) => {
          this.form = response.data
          if (this.form.contractImg != null && this.form.contractImg.length > 0) {
            const contractImgs = this.form.contractImg.split(',')
            contractImgs.forEach(element => {
              this.pictureList.push({
                url: element
              })
            })
          }
          this.forField()
          this.show = true
        })
      } else if (verifyStatus == '1') {
        newContract.getContract(contractId).then((response) => {
          this.form = response.data
          if (this.form.contractImg != null && this.form.contractImg.length > 0) {
            const contractImgs = this.form.contractImg.split(',')
            contractImgs.forEach(element => {
              this.pictureList.push({
                url: element
              })
            })
          }
          this.forField()
          this.show = true
        })
      } else if (verifyStatus == '2') {
        getFailContract(contractId).then((response) => {
          this.form = response.data
          if (this.form.contractImg != null && this.form.contractImg.length > 0) {
            const contractImgs = this.form.contractImg.split(',')
            contractImgs.forEach(element => {
              this.pictureList.push({
                url: element
              })
            })
          }
          this.forField()
          this.show = true
        })
      }
    },
    forField() {
      this.contractTypeOptions = this.$store.state.dictOptions.contractType
      this.contractStatusOptions = this.$store.state.dictOptions.contractStatus
      this.payModeOptions = this.$store.state.dictOptions.payMode
      const contractType = this.contractTypeOptions.find((item, index) => {
        return item.dictValue == this.form.contractType
      })
      const contractStatus = this.contractStatusOptions.find((item, index) => {
        return item.dictValue == this.form.contractStatus
      })
      const payMode = this.payModeOptions.find((item, index) => {
        return item.dictValue == this.form.payMode
      })
      if (contractType != null) {
        this.form.contractTypeName = contractType.dictLabel
      }
      if (contractStatus != null) {
        this.form.contractStatusName = contractStatus.dictLabel
      }
      if (payMode != null) {
        this.form.payModeName = payMode.dictLabel
      }
    },
    handleAdd() {
      this.title = '添加其他合同'
      this.reset()
      this.show = true
    },
    // readFile(url, title) {
    //   this.readTitle = title;
    //   this.pdfSrc = url;
    //   this.getNumPages(this.pdfSrc);
    //   this.readFiles = true;
    // },
    reset() {
      this.form = {
        contractId: null,
        custOrderId: null,
        contractNum: null,
        contractName: null,
        custId: null,
        custName: null,
        contractSource: null,
        contractType: null,
        contractStatus: null,
        businessTypeName: null,
        businessType: null,
        payMode: null,
        contractTypeName: null,
        contractStatusName: null,
        payModeName: null,
        hkStatus: null,
        verifyStatus: null,
        contractMoney: null,
        allReturnedMoney: null,
        noReturnedMoney: null,
        startTime: null,
        endTime: null,
        signedUserMobile: null,
        custSignedUser: null,
        mySignedUser: null,
        signTime: null,
        contractImg: null,
        contractFile: null,
        annexOne: null,
        annexTwo: null,
        content: null,
        readerCount: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: '0',
        delFlag: null,
        remark: null
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import url("@/style/index.less");
/* 基本信息 */
.tab-line  /deep/.van-tabs__line{
    position: absolute;
    bottom: 0.4rem;
    left: 0;
    z-index: 1;
    width: 1.06667rem;
    height: 0.08rem;
    background-color: #0a315d;
    border-radius: 0.08rem;
}

.pdf-box {
  // -webkit-box-sizing: border-box;
  // box-sizing: border-box;
  max-width: 1024px;
  width: 100%;
  // overflow-x: hidden;
  height: 900px;
  // overflow-y: auto;
  // -webkit-overflow-scrolling: touch;
  font-size: 0.36rem;
  overflow: scroll;
  span {
    width: 100%;
  }
}
.custclue-container {
  height: 100vh;
  background-color: #eee;
  font-size: 20px;
  overflow:auto;
  .title {
    display: grid;
    align-items: center;
    font-weight: bold;
    grid-template-columns: auto auto auto auto;
    grid-template-columns: 1fr 18fr 2fr 2fr;
    padding-bottom: 20px;
    span {
      margin-left: 5px;
      font-size: 30px;
      font-weight: bold;
    }
    i {
      font-size: 14px;
      color: #ccc;
      margin-left: 5px;
      font-style: normal;
    }
    .icon {
      display: inline-block;
      width: 52px;
      height: 52px;
    }
  }
  .section {
    padding-top: 20px;
  }
  .title_name {
    font-size: 30px;
    padding: 20px 0;
  }
  .custclue-header {
    display: flex;
    align-items: center;
    font-size: 18px;
    padding: 20px 10px 10px 30px;
  }
  .tag-wrapper {
    display: flex;
    justify-content: center;
  }
  .b-g-w {
    background-color: #fff;
  }
  .m-b-20 {
    margin-bottom: 20px;
  }

  .key{
    font-size: 0.38rem;
    color: #959595;
    width: 1.9rem;
    text-align: left;
  }
  .key3{
    font-size: 0.38rem;
    color: #333;
    width: 2.3rem;
    text-align: left;
  }
  .value{
    font-size: 0.38rem;
    color:#000000;
  }
  .concat-container {
    background-color: #fff;
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 90px;
    .concat-header {
      padding: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .concat-list {
      .concat-item {
        border-bottom: 1px solid #eee;
        margin-left: 15px;
        margin-right: 15px;
        padding: 20px;
        .content-footer {
          color: #ccc;
        }
        span {
          font-size: 22px;
        }
      }
    }
  }
}
.payimg {
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  .title {
    margin-top: 10px;
  }
  .imgList {
    width: 100%;
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    .img {
      width: 120px;
      height: 100px;
      margin-right: 10px;
      margin-bottom: 10px;
      // margin-left: 15px;
    }
  }
}
.flex-1 {
  display: flex;
  flex: 1;
}
.card-box {
  display: flex;
  margin-bottom: 0.35rem;
  font-size: 28px;
  color: #999;
  .value {
    flex: 1;
  }
}
.grid-span {
  font-size: 30px;
  color: #646566;
  a {
    color: #646566;
  }
}
.grid-span-1 {
  font-size: 12px;
  color: #646566;
}
.van-grid {
  margin-bottom: 10px;
}
.van-grid-item {
  flex: 1;
}
.van-divider {
  margin-top: 20px 0;
}
.van-list{
    padding-top: 0;
}
</style>
